import { Component, inject } from '@angular/core';
import {
  UnauthPageIntroComponent,
  UnauthenticatedForwardNavService,
  UnauthenticatedPageComponent,
} from '@crowdctrl/shared';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { arrowForwardOutline } from 'ionicons/icons';

addIcons({ arrowForwardOutline });

@Component({
  selector: 'app-unauthorized',
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent, IonButton, IonIcon],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css', '../../styles/shared-marketing-about-page.css'],
})
export class UnauthorizedComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);

  go(event: Event, path: string): void {
    void this.unauthNav.forward(event, path);
  }
}
